import * as navigation from 'Navigation';

export default class CanvasFolderArtifactTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Artifact',
      closeable: false,
      preferenceKey: 'canvas-folder-artifact',
    };
  }
}
